import { Shield, Briefcase, Building2 } from 'lucide-react';

const AGENCY_ICONS = {
    MPS: Shield,
    Customs: Building2,
    Forensics: Briefcase,
    Investigation: Shield,
    Border: Building2,
    default: Building2,
};

function getAgencyIcon(name) {
    const upper = (name || '').toUpperCase();
    for (const [key, Icon] of Object.entries(AGENCY_ICONS)) {
        if (upper.includes(key)) return Icon;
    }
    return AGENCY_ICONS.default;
}

export default function ClientFitPanel({ clientFit }) {
    if (!clientFit) return null;

    const agencies = clientFit.agencies || [];
    const useCases = clientFit.use_cases || clientFit.useCases || '';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {/* Agency chips */}
            {agencies.length > 0 && (
                <div>
                    <h4 style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Target Agencies
                    </h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                        {agencies.map((agency, idx) => {
                            const Icon = getAgencyIcon(agency);
                            return (
                                <span
                                    key={idx}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '0.35rem',
                                        background: 'rgba(212,175,55,0.1)',
                                        border: '1px solid rgba(212,175,55,0.3)',
                                        borderRadius: '9999px',
                                        padding: '0.3rem 0.75rem',
                                        fontSize: '0.8rem',
                                        color: 'var(--gold)',
                                    }}
                                >
                                    <Icon size={12} />
                                    {agency}
                                </span>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* Use cases */}
            {useCases && (
                <div>
                    <h4 style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Use Cases
                    </h4>
                    <p style={{ color: 'var(--text-primary)', fontSize: '0.9rem', lineHeight: 1.6, margin: 0 }}>
                        {useCases}
                    </p>
                </div>
            )}
        </div>
    );
}